import { revokeSession } from "@/api/oauthApi";
import { clearIdleSession } from "@/auth/idleSession";
import { useAccountStore } from "@/stores/accountStore";
import { isOAuthSession } from "@/stores/authStore";

export const SIGN_OUT_SIGNAL_KEY = "xola.auth.signedOutAt";

export enum SignOutReason {
    IDLE = "idle",
}

interface SignOutSignal {
    at: number;
    reason?: SignOutReason;
}

export const readSignOutSignalReason = (value: string | null): SignOutReason | undefined => {
    try {
        return (JSON.parse(value ?? "") as SignOutSignal | null)?.reason;
    } catch {
        return undefined;
    }
};

export const signOut = async (reason?: SignOutReason) => {
    if (isOAuthSession()) {
        try {
            await revokeSession();
        } catch {
            // A server that will not answer must not keep the user signed in; the token expires on its own.
        }

        // The timestamp keeps each write unique: rewriting the same value fires no storage event in other tabs.
        const signal: SignOutSignal = { at: Date.now(), reason };
        localStorage.setItem(SIGN_OUT_SIGNAL_KEY, JSON.stringify(signal));
    }

    // Clear idle values unless this is an idle sign-out; those stay so other tabs see the deadline passed and sign out too.
    if (reason !== SignOutReason.IDLE) {
        clearIdleSession();
    }
    useAccountStore.getState().forget(true, reason);
};
